import React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { SlidersHorizontal } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtINR } from "@/lib/stayflowApi";

const RangeSlider = ({ value, min, max, step, onValueChange }) => (
  <SliderPrimitive.Root className="relative flex w-full touch-none select-none items-center py-2" value={value} min={min} max={max} step={step} onValueChange={onValueChange} minStepsBetweenThumbs={1}>
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-black/10">
      <SliderPrimitive.Range className="absolute h-full bg-brand" />
    </SliderPrimitive.Track>
    {value.map((_, i) => (
      <SliderPrimitive.Thumb key={i} className="block h-5 w-5 rounded-full border-2 border-brand bg-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/40" />
    ))}
  </SliderPrimitive.Root>
);

export const PriceFilter = ({ priceRange, setPriceRange, priceBounds }) => {
  if (!priceBounds || priceBounds[1] <= priceBounds[0]) return null;
  const active = priceRange[0] > priceBounds[0] || priceRange[1] < priceBounds[1];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className={`h-10 inline-flex items-center gap-2 rounded-full border px-4 text-sm font-medium transition-colors ${active ? "border-brand text-brand bg-brand-soft" : "border-black/10 text-ink bg-white hover:border-black/20"}`} data-testid="filter-price">
          <SlidersHorizontal className="w-4 h-4" />
          {active ? `${fmtINR(priceRange[0])} – ${fmtINR(priceRange[1])}` : "Price"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72" align="end">
        <p className="text-sm font-heading font-semibold text-ink">Price per night</p>
        <div className="mt-4"><RangeSlider value={priceRange} min={priceBounds[0]} max={priceBounds[1]} step={100} onValueChange={setPriceRange} /></div>
        <div className="mt-2 flex justify-between text-sm text-ink-soft">
          <span data-testid="filter-price-min">{fmtINR(priceRange[0])}</span>
          <span data-testid="filter-price-max">{fmtINR(priceRange[1])}</span>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default PriceFilter;
